import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { venueRoomApi } from '~/entities/listing/api/venue-room-api'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'

const STATUS_POLL_MS = 30_000

/** Tonight's venue room, polled while the tab is visible. */
export function useVenueRoomStatus(businessId: string, listingId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.LISTING_VENUE_ROOM, listingId),
    queryFn: () => venueRoomApi.status(businessId, listingId),
    staleTime: 0,
    refetchInterval: STATUS_POLL_MS,
    enabled: !!businessId && !!listingId,
  })
}

export function useVenueAnnouncement(businessId: string, listingId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (text: string) => venueRoomApi.announce(businessId, listingId, text),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.LISTING_VENUE_ROOM, listingId),
      }),
  })
}
